import { render } from "./FamilyAccount.vue?vue&type=template&id=2924e0f5&scoped=true"
import script from "./FamilyAccount.vue?vue&type=script&lang=js"
export * from "./FamilyAccount.vue?vue&type=script&lang=js"

import "./FamilyAccount.vue?vue&type=style&index=0&id=2924e0f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2924e0f5"]])

export default __exports__